function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect, useState } from 'react';
import { useOverlayContext, useStateInRef, GridItem, TextButton } from 'seagull';
import ContactPicker from "../../../ContactsPicker/ContactPicker";
import { ManageContactModalForVendor } from "../../../ManageContactModal";
import { useFeatureFlags } from "../../../../hooks/useFeatureFlags";
import { handlePromise } from "../../../../infra/utils";
import { NewContactModel } from "../../../../models/ContactModel";
import { useStoreActions } from "../../../../store/store-context";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function calculateCanEditContact(existingContact) {
  return !!existingContact && existingContact.isEditable() && !existingContact.isSample();
}
function calculateCanEditContactV2(existingContact, allowEditContactFF) {
  if (!existingContact) {
    return false;
  }
  return allowEditContactFF && !existingContact.isSample();
}
export default function ContactDetails(props) {
  const {
    existingContact,
    refreshExistingContacts,
    onChange: _onChange,
    onValidation = () => {},
    showCustomerDetailsWarning,
    hideEditContact,
    ['data-testid']: testid,
    disabled
  } = props;
  const getProps = useStateInRef(_objectSpread(_objectSpread({}, props), {}, {
    openContactModal,
    newContactPostActions
  }));
  const overlayContext = useOverlayContext();
  const {
    api
  } = useStoreActions();
  const {
    ALLOW_EDIT_CONTACT
  } = useFeatureFlags();
  const [canEditContact, setCanEditContact] = useState(() => ALLOW_EDIT_CONTACT ? calculateCanEditContactV2(existingContact, true) : calculateCanEditContact(existingContact));
  const showEditContact = !hideEditContact && canEditContact;
  useEffect(() => {
    const newContact = NewContactModel.makeEmpty();
    if (newContact.hasPartialContactDetails() && !existingContact) {
      handlePromise(api.contact.create(newContact)).then(async newContact => {
        if (newContact.success) {
          await getProps().newContactPostActions({
            id: newContact.data.id(),
            version: newContact.data.version()
          });
        } else {
          const savedContact = await getProps().openContactModal({
            newContactToCreate: newContact.data
          });
          await getProps().newContactPostActions(savedContact);
        }
      });
    }
    setCanEditContact(ALLOW_EDIT_CONTACT ? calculateCanEditContactV2(existingContact, true) : calculateCanEditContact(existingContact));
  }, [existingContact, ALLOW_EDIT_CONTACT]);
  async function openContactModal(props) {
    return overlayContext.showModal({
      closeOnEscapeKey: false,
      closeOnClickOutside: false,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/_jsx(ManageContactModalForVendor, _objectSpread(_objectSpread({}, props), {}, {
          "data-testid": "manage-contact-modal",
          onClose: dismissModal,
          origin: "Agreement studio"
        }));
      }
    });
  }
  async function newContactPostActions(savedContactData) {
    if (savedContactData) {
      await refreshExistingContacts();
      onValidation(true);
      _onChange({
        type: 'existingContact',
        id: savedContactData.id
      });
    } else {
      onValidation(false);
    }
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(GridItem, {
      span: showEditContact ? 9 : 12,
      children: /*#__PURE__*/_jsx(ContactPicker, {
        label: "Primary contact",
        disabled: disabled,
        value: existingContact !== null && existingContact !== void 0 ? existingContact : NewContactModel.makeEmpty(),
        onChange: async change => {
          switch (change.type) {
            case 'initial':
              onValidation(true);
              _onChange({
                type: 'noContact'
              });
              break;
            case 'existingContact':
              onValidation(true);
              _onChange({
                type: 'existingContact',
                id: change.id
              });
              break;
            case 'newContact':
              {
                const savedContact = await openContactModal({});
                await newContactPostActions(savedContact);
                break;
              }
            case 'sampleContact':
              onValidation(true);
              _onChange({
                type: 'sampleContact'
              });
              break;
            default:
              break;
          }
        },
        "data-testid": testid,
        error: showCustomerDetailsWarning,
        helperText: "Please select a contact"
      })
    }), showEditContact && /*#__PURE__*/_jsx(GridItem, {
      span: 3,
      children: /*#__PURE__*/_jsx(TextButton, {
        "data-testid": "edit-contact",
        disabled: disabled,
        onClick: async () => {
          const shouldRefresh = await openContactModal({
            existingContact
          });
          if (shouldRefresh) {
            await refreshExistingContacts();
          }
        },
        children: "Edit contact"
      })
    })]
  });
}